import Vue from 'vue';
import IdleVue from 'idle-vue';

Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime: 90000,
  keepTracking: true
});



// WEBPACK FOOTER //
// ./src/plugins/idle-vue.js